import Vue from 'vue'
import $store from '@/store'
import VueCache from '@/services/cache'

const API_BASE_URL = process.env.API_BASE_URL + '/v1/memberships'

let cache = new VueCache('tiers', { expiration: 150 })

export default {
  initCache() {
    Vue.http.interceptors.push((req) => {
      if (req.fresh) cache.del(req.url)
      if (req.url.startsWith(API_BASE_URL) && req.method === 'GET') {
        var valid = cache.get(req.url)
        if (valid) {
          return req.respondWith(valid, {
            status: 200,
            statusText: 'OK',
          })
        } // if nothing is returned, continue
      }

      return (res) => {
        if (res && res.status === 200 && res.url.startsWith(API_BASE_URL)) {
          cache.set(res.url, res.body)
        }
        return res
      }
    })
  },

  purchaseMembership(params) {
    return Vue.http.post(API_BASE_URL, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  updateMembership(membershipId, params) {
    return Vue.http.put(`${API_BASE_URL}/${membershipId}`, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  getMembers(tierFilter, daysFilter, q) {
    return Vue.http.get(`${API_BASE_URL}/members`, {
      headers: { Authorization: $store.state.auth.token },
      params: { 'tier_filter': tierFilter, 'days_filter': daysFilter, 'search': q },
    })
  },

  deleteMembership(membershipId) {
    return Vue.http.delete(`${API_BASE_URL}/${membershipId}`, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  addToGuestlist(params) {
    return Vue.http.post(`${API_BASE_URL}/add_to_guestlist`, params, {
      headers: { Authorization: $store.state.auth.token },
    })
  },

  removeFromGuestlist(membershipId) {
    return Vue.http.delete(`${API_BASE_URL}/${membershipId}/remove_from_guestlist`, {
      headers: { Authorization: $store.state.auth.token },
    })
  },
}



// WEBPACK FOOTER //
// ./src/services/membership.js